module.exports = __webpack_public_path__ + "img/154.f4bc0d08.png";